module.exports = __webpack_public_path__ + "img/yritysluotto.bb7af3a.png";